<template>
  <div class="content-wrapper">
    <div class="d-flex align-items-center justify-content-between">
      <app-breadcrumb :page-title="$t('working_shift_requests')"/>

      <div>
        <a :href="urlGenerator('/administration/work-shifts')" class="btn btn-success mr-2 mb-4">
          <app-icon class="size-20 mr-2" name="arrow-left"/>
          {{ $t('back_to_workshift') }}
        </a>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="triggerActions"/>

    <!--    <app-confirmation-modal
            v-if="isRejectModalActive"
            modal-id="app-reject-modal"
            @confirmed="confirmed('work-shift-request-table')"
            @cancelled="cancelled"
            icon="trash-2"
            sub-title=""
            message="This request will be rejected."
            modal-class="danger"
        />-->

    <!--    <app-confirmation-modal-->
    <!--        v-if="isApproveModalActive"-->
    <!--        modal-id="app-approve-modal"-->
    <!--        @confirmed="confirmed('work-shift-request-table')"-->
    <!--        @cancelled="cancelled"-->
    <!--        icon="check-circle"-->
    <!--        sub-title=""-->
    <!--        message="This request will be approved."-->
    <!--        modal-class="success"-->
    <!--    />-->

    <app-modal modal-id="app-approve-modal" modal-alignment="center" modal-size="md" v-if="isApproveModalActive"
               @close="isApproveModalActive = false">
      <div class="modal-body d-flex flex-column justify-content-center modal-alert">
        <div class="text-center">
          <app-icon name="check-circle" class="text-success"/>
        </div>
        <h5 class="text-center font-weight-bold mt-4">Are you sure?</h5>
        <p class="mb-primary text-center font-size-90 p-0">This request will be approved.</p>
        <div class="text-center">
          <button data-dismiss="modal" class="btn btn-secondary mr-2">
            No
          </button>
          <button data-dismiss="modal" class="btn btn-success" @click="approveRequest">
            Yes
          </button>
        </div>
      </div>
    </app-modal>

    <app-modal modal-id="app-approve-modal" modal-alignment="center" modal-size="md" v-if="isRejectModalActive"
               @close="isRejectModalActive = false">
      <div class="modal-body d-flex flex-column justify-content-center modal-alert">
        <div class="text-center">
          <app-icon name="trash-2" class="text-danger"/>
        </div>
        <h5 class="text-center font-weight-bold mt-4">Are you sure?</h5>
        <p class="mb-primary text-center font-size-90 p-0">
          This request will be rejected.</p>
        <div class="text-center">
          <button data-dismiss="modal" class="btn btn-secondary mr-2">
            No
          </button>
          <button data-dismiss="modal" class="btn btn-danger" @click="rejectRequest">
            Yes
          </button>
        </div>
      </div>
    </app-modal>

  </div>
</template>

<script>

import {axiosPatch, urlGenerator} from '../../../../../common/Helper/AxiosHelper';
import DatatableHelperMixin from "../../../../../common/Mixin/Global/DatatableHelperMixin";
import {WORK_SHIFT_REQUESTS} from "../../../../Config/ApiUrl";
import BreakTimeCreateEditModal from "./BreakTime/BreakTimeCreateEditModal";

export default {
  name: "Working_Shift_Requests",
  components: {BreakTimeCreateEditModal},
  mixins: [DatatableHelperMixin],
  data() {
    return {
      urlGenerator,
      isRejectModalActive: false,
      isApproveModalActive: false,
      selectedUrl: '',
      tableId: 'work-shift-request-table',
      message: '',
      rowData: null,
      options: {
        url: WORK_SHIFT_REQUESTS,
        name: 'work-shift-request-table',
        columns: [
          {
            title: this.$t('title'),
            type: 'text',
            key: 'title',
          },
          {
            title: this.$t('comment'),
            type: 'text',
            key: 'comment',
          },
          {
            title: this.$t('user'),
            type: 'custom-html',
            key: 'user',
            modifier: user => {
              return user.full_name
            }
          },
          {
            title: this.$t('status'),
            type: 'custom-html',
            key: 'status',
            modifier: status => {
              if (!status) {
                return '-'; // Return a dash if no status is provided
              }

              // Define badge classes based on the status
              let badgeClass = '';
              switch (status) {
                case 'Pending':
                  badgeClass = 'warning';  // Yellow for Pending
                  break;
                case 'Approved':
                  badgeClass = 'success';  // Green for Approved
                  break;
                case 'Rejected':
                  badgeClass = 'danger';   // Red for Rejected
                  break;
                default:
                  badgeClass = 'secondary'; // Default to secondary for unknown status
              }

              // Return the formatted badge with capitalized status
              return `<span class="badge badge-pill badge-${badgeClass} text-capitalize">${this.$t(status)}</span>`;
            }
          },
          {
            title: this.$t('actions'),
            type: 'action'
          }
        ],
        filters: [],
        actions: [
          {
            title: this.$t('approve'),
            name: 'approve',
            component: 'app-confirmation-modal',
            icon: 'check-circle'
          },
          {
            title: this.$t('reject'),
            name: 'reject',
            icon: 'x-circle'
          },
        ],
        rowLimit: 10,
        orderBy: 'desc',
        responsive: true,
        showHeader: true,
        showFilter: true,
        showSearch: true,
        showAction: true,
        tableShadow: true,
        actionType: 'default',
        datatableWrapper: true,
        paginationType: 'pagination'
      },
    }
  },
  methods: {
    // openModal() {
    //   this.selectedUrl = '';
    //   this.isRejectModalActive = true;
    // },
    approveRequest() {
      axiosPatch(`${this.selectedUrl}`, {request_id: this.rowData.id, status: 'Approved'})
      .then((res) => {
        // this.$toastr.s(res.data.message);
        this.toastAndReload(res.data.message, 'work-shift-request-table');
      }).catch((error)=> {
        this.$toastr.e(error.response.data.message)
      });
    },
    rejectRequest() {
      axiosPatch(`${this.selectedUrl}`, {request_id: this.rowData.id, status: 'Rejected'})
          .then((res) => {
            this.toastAndReload(res.data.message, 'work-shift-request-table');
          }).catch((error)=> {
        this.$toastr.e(error.response.data.message)
      })
    },
    triggerActions(row, action, active) {
      if (action.name === 'approve') {
        this.selectedUrl = `${WORK_SHIFT_REQUESTS}/${row.id}`;
        this.rowData = row;
        this.isApproveModalActive = true;
      } else if (action.name === 'reject') {
        this.selectedUrl = `${WORK_SHIFT_REQUESTS}/${row.id}`;
        this.rowData = row;
        // this.delete_url = `${WORK_SHIFT_REQUESTS}/${row.id}`;
        // this.message = action.message;
        this.isRejectModalActive = true;
      }
    }
  }
}
</script>